import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Creatives } from 'reducers/Creatives';

export default function useActiveCreative(creativeId) {
	const dispatch = useDispatch();
	const creatives = useSelector(state => state.creatives?.items);

	useEffect(() => {
		if (creativeId && creatives?.length) {
			dispatch(Creatives.setActiveCreative(creativeId));
		}

		return () => {
			dispatch(Creatives.clearActiveCreative());
		};
	}, [creativeId, creatives]);
}

export function ActiveCreative(props) {
	const { creativeId, children } = props;
	useActiveCreative(creativeId);

	return children;
}
